import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface SoftphoneCallEndedScreenProps {
  /** Cerrar intenta window.close; si la PWA sigue, vuelve al login (sin quedarse atrapado). */
  onDismiss: () => void;
}

/**
 * Tras colgar en quick-answer. Solo título + Cerrar.
 * No atrapa al usuario: dismiss → login para usar el resto de la app.
 */
const SoftphoneCallEndedScreen: React.FC<SoftphoneCallEndedScreenProps> = ({ onDismiss }) => {
  const { t } = useTranslation();

  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 20000,
        backgroundColor: '#000',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2.5,
        px: 3,
        textAlign: 'center',
      }}
    >
      <Typography
        sx={{
          color: '#fff',
          fontSize: '1.25rem',
          fontWeight: 600,
          letterSpacing: 0.3,
        }}
      >
        {t('softphone.callEnded.title')}
      </Typography>
      <Button
        variant="contained"
        onClick={() => {
          onDismiss();
        }}
        sx={{
          backgroundColor: '#2391FF',
          textTransform: 'none',
          fontWeight: 600,
          px: 3,
          '&:hover': { backgroundColor: '#1a7ae0' },
        }}
      >
        {t('softphone.callEnded.closeButton')}
      </Button>
    </Box>
  );
};

export default SoftphoneCallEndedScreen;
